module.exports = __webpack_public_path__ + "img/contact-icon05.a8664681.png";